import { render, staticRenderFns } from "./resourceCenter.vue?vue&type=template&id=47a80a35&scoped=true&"
import script from "./resourceCenter.vue?vue&type=script&lang=js&"
export * from "./resourceCenter.vue?vue&type=script&lang=js&"
import style0 from "./resourceCenter.vue?vue&type=style&index=0&id=47a80a35&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a80a35",
  null
  
)

export default component.exports